import { DeleteCreditCard } from '@/domain/usecases'
import { RemoteDeleteCreditCard } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeDeleteCreditCard = (): DeleteCreditCard => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteDeleteCreditCard(url, httpClient)
}
